module.exports = __webpack_public_path__ + "img/solaris.8d5e3be1.png";